// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.conditionCheck {
  width: 25px;
  margin: 0 57px 0 auto;
}

.userDetail {
  max-width: 200px;
  min-width: 200px;
}

.addStratification {
  position: relative;
  background-color: #297DFD;
  margin-top: -75px !important;
}

.saveStratification {
  background-color: #297DFD;
}

#customStrat {
  height: 3em;
  width: 16em;
}

input::placeholder {
  color: gray !important;
}

textarea::placeholder {
  color: gray !important;
}

.flex-container {
  display: flex;
  align-items: center;
}

  .flex-container .label {
    margin-right: 10px;
  }

  .flex-container .form-control {
    flex: 1;
  }

.full-width {
  width: 100%;
}

.mat-form-field {
  width: 100%;
}

.mat-select-panel {
  max-height: 300px;
  overflow-y: auto;
}

.mat-option {
  white-space: nowrap;
}

.spinner-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.fa-spinner {
  font-size: 4em;
}

.spinner-container p {
  margin-top: 10px;
  font-size: 1.2em;
  color: #000;
}

.txtWid input {
  width: 100% !important;
}

.errorText {
  color: #dc3545;
  font-size: 80%;
  margin-top: .25rem;
  word-wrap: break-word;
  white-space: normal;
  overflow-wrap: break-word;
  max-width: 200px;
}

.is-invalid-no-icon {
  border-color: #dc3545 !important;
  padding-right: 0.75rem !important;
  background-image: none !important;
  background-repeat: no-repeat !important;
  background-position: right calc(0.375em + 0.1875rem) center !important;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) !important;
}

  .is-invalid-no-icon:focus {
    border-color: #dc3545 !important;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
  }

.was-validated .form-control:invalid, .form-control.is-invalid {
  background-image: none !important;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  appearance: none;
}

.gender-check-row {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  position: relative;
  padding-left: revert-layer;
}

.gender-check-row .custom-control-label {
  line-height: 1.2;
  margin-top: 0;
  margin-left: 0.5rem;
  position: static;
  padding-left: 0;
}

.gender-check-row .gender-native-input {
  position: static !important;
  clip: auto !important;
  clip-path: none !important;
  width: 18px !important;
  height: 18px !important;
  left: auto !important;
  top: auto !important;
  margin: 0 !important;
  opacity: 1 !important;
  visibility: visible !important;
  appearance: auto !important;
  -webkit-appearance: checkbox !important;
}

.gender-check-row .gender-native-input ~ .custom-control-label::before,
.gender-check-row .gender-native-input ~ .custom-control-label::after {
  content: none !important;
  display: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/admin/admin_demographic_list/admin_demographic_list.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;EAEE;IACE,kBAAkB;EACpB;;EAEA;IACE,OAAO;EACT;;AAEF;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,iCAAiC;EACjC,uCAAuC;EACvC,sEAAsE;EACtE,2EAA2E;AAC7E;;EAEE;IACE,gCAAgC;IAChC,2DAA2D;EAC7D;;AAEF;EACE,iCAAiC;AACnC;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,8BAA8B;EAC9B,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;;EAEE,wBAAwB;EACxB,wBAAwB;AAC1B","sourcesContent":[".conditionCheck {\r\n  width: 25px;\r\n  margin: 0 57px 0 auto;\r\n}\r\n\r\n.userDetail {\r\n  max-width: 200px;\r\n  min-width: 200px;\r\n}\r\n\r\n.addStratification {\r\n  position: relative;\r\n  background-color: #297DFD;\r\n  margin-top: -75px !important;\r\n}\r\n\r\n.saveStratification {\r\n  background-color: #297DFD;\r\n}\r\n\r\n#customStrat {\r\n  height: 3em;\r\n  width: 16em;\r\n}\r\n\r\ninput::placeholder {\r\n  color: gray !important;\r\n}\r\n\r\ntextarea::placeholder {\r\n  color: gray !important;\r\n}\r\n\r\n.flex-container {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n  .flex-container .label {\r\n    margin-right: 10px;\r\n  }\r\n\r\n  .flex-container .form-control {\r\n    flex: 1;\r\n  }\r\n\r\n.full-width {\r\n  width: 100%;\r\n}\r\n\r\n.mat-form-field {\r\n  width: 100%;\r\n}\r\n\r\n.mat-select-panel {\r\n  max-height: 300px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.mat-option {\r\n  white-space: nowrap;\r\n}\r\n\r\n.spinner-container {\r\n  position: fixed;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.fa-spinner {\r\n  font-size: 4em;\r\n}\r\n\r\n.spinner-container p {\r\n  margin-top: 10px;\r\n  font-size: 1.2em;\r\n  color: #000;\r\n}\r\n\r\n.txtWid input {\r\n  width: 100% !important;\r\n}\r\n\r\n.errorText {\r\n  color: #dc3545;\r\n  font-size: 80%;\r\n  margin-top: .25rem;\r\n  word-wrap: break-word;\r\n  white-space: normal;\r\n  overflow-wrap: break-word;\r\n  max-width: 200px;\r\n}\r\n\r\n.is-invalid-no-icon {\r\n  border-color: #dc3545 !important;\r\n  padding-right: 0.75rem !important;\r\n  background-image: none !important;\r\n  background-repeat: no-repeat !important;\r\n  background-position: right calc(0.375em + 0.1875rem) center !important;\r\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) !important;\r\n}\r\n\r\n  .is-invalid-no-icon:focus {\r\n    border-color: #dc3545 !important;\r\n    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;\r\n  }\r\n\r\n.was-validated .form-control:invalid, .form-control.is-invalid {\r\n  background-image: none !important;\r\n}\r\n\r\ninput[type=number]::-webkit-inner-spin-button,\r\ninput[type=number]::-webkit-outer-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0;\r\n}\r\n\r\ninput[type=number] {\r\n  -moz-appearance: textfield;\r\n  appearance: none;\r\n}\r\n\r\n.gender-check-row {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 0.5rem;\r\n  position: relative;\r\n  padding-left: revert-layer;\r\n}\r\n\r\n.gender-check-row .custom-control-label {\r\n  line-height: 1.2;\r\n  margin-top: 0;\r\n  margin-left: 0.5rem;\r\n  position: static;\r\n  padding-left: 0;\r\n}\r\n\r\n.gender-check-row .gender-native-input {\r\n  position: static !important;\r\n  clip: auto !important;\r\n  clip-path: none !important;\r\n  width: 18px !important;\r\n  height: 18px !important;\r\n  left: auto !important;\r\n  top: auto !important;\r\n  margin: 0 !important;\r\n  opacity: 1 !important;\r\n  visibility: visible !important;\r\n  appearance: auto !important;\r\n  -webkit-appearance: checkbox !important;\r\n}\r\n\r\n.gender-check-row .gender-native-input ~ .custom-control-label::before,\r\n.gender-check-row .gender-native-input ~ .custom-control-label::after {\r\n  content: none !important;\r\n  display: none !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
